// The uniq utility can be typed as function uniq<T>(arr: T[]): T[]
// since it returns an array of the same type with duplicates removed using Set.
// export function uniq<T>(arr:T[]): T[] { return Array.from(new Set(arr)); }
interface UniqFunction {
  <T>(arr: T[]): T[];
}
export const uniq: UniqFunction = (arr) => Array.from(new Set(arr));